export default "__VITE_ASSET__B9V0wgHP__"